import { http } from 'utils'

import {
  OrdersWestfieldCons,
  OrdersWestfieldConsData,
  OrdersWestfieldConsUpdateParamsTypes,
  SourceName,
  OrdersWestfieldConsAPITypes,
  OrdersWestfieldConsFetchParamsTypes,
} from 'types/orders-westfieldcons'
import { OrdersWestfieldConsAPISchemas } from 'schemas/orders-westfieldcons-schemas'

import { DATASTATUS } from 'constants/status'
import { formatDateToShort } from 'services/helpers'

export async function postOrdersWestfieldConsAPI({
  traderId,
  enrolmentTraderId,
  orderId,
  orderStatusId,
  traderName,
  startDate,
  endDate,
}: OrdersWestfieldConsFetchParamsTypes): Promise<OrdersWestfieldConsAPITypes> {
  const url = '/orders/consumer'

  // if (startDate) {
  //   params.set('startDate', startDate)
  // }

  // if (endDate) {
  //   endDate = new Date(
  //     new Date(endDate).getFullYear(),
  //     new Date(endDate).getMonth(),
  //     new Date(endDate).getDate(),
  //     23,
  //     59,
  //     59
  //   ).toString()
  //   endDate =
  //     formatDateToShort(new Date(endDate)) +
  //     ' ' +
  //     new Date(endDate).getHours() +
  //     ':' +
  //     new Date(endDate).getMinutes() +
  //     ':' +
  //     new Date(endDate).getSeconds()
  //   params.set('endDate', endDate)
  // }

  // PAGE SIZE AND NUMBER IS TO DO
  // if (pSize) {
  //   params.set('pSize', pSize.toString())
  // }

  // if (pNumber) {
  //   params.set('pNumber', pNumber.toString())
  // }

  const data = {
    traderId,
    startDate,
    endDate,
  }

  const response = await http.post<unknown>(url, data)
  const validatedData = OrdersWestfieldConsAPISchemas.safeParse(response.data)

  if (!validatedData.success) {
    return {
      data: [],
      outcomeMessage: JSON.stringify(validatedData.error),
      ...DATASTATUS,
    }
  }
  return validatedData.data
}
